module.exports = __webpack_public_path__ + "img/14-4.e6163d22.png";